export default __webpack_public_path__ + "static/media/borku-facebook.405aa29b.svg";